export const HeroImagePlacements = {
	RIGHT: 'Right',
	LEFT: 'Left',
} as const;

export const HERO_IMG_PLACEMENTS = Object.values(HeroImagePlacements);

export type HeroImagePlacementName = (typeof HERO_IMG_PLACEMENTS)[number];

export const FormInitialValues = {
	asid: '[asid]',
	aid: '[aid]',
	cid: '[cid]',
	fb_adset_name: '[fb_adset_name]',
	utm_campaign: '[utm_campaign]',
	utm_content: '[utm_content]',
	utm_medium: '[utm_medium]',
	utm_source: '[utm_source]',
	affid: '[affid]',
	efid: '[efid]',
	cr: '[cr]',
	mediabuy: '[mediabuy]',
	request_id: '[request_id]',
	connection_id: '[connection_id]',
	referrer: '[referrer]',
	ua: '[ua]',
	anura_response: '',
	fsid: '[FSID]',
	pageurl: '',
};

export const TextAlignmentOptions = {
	...HeroImagePlacements,
	CENTER: 'Center',
} as const;

export const TEXT_ALIGNMENT_OPTIONS = Object.values(TextAlignmentOptions);

export type TextAlignmentOptionsName = (typeof TEXT_ALIGNMENT_OPTIONS)[number];

export const ImageAlignmentOptions = {
	TOP: 'Top',
	BOTTOM: 'Bottom',
} as const;

export const IMAGE_ALIGNMENT_OPTIONS = Object.values(ImageAlignmentOptions);

export type ImageAlignmentOptionsName = (typeof IMAGE_ALIGNMENT_OPTIONS)[number];

export const BgImageAlignmentOptions = {
	CENTER: 'Center',
	TOP: 'Top',
	BOTTOM: 'Bottom',
	RIGHT: 'Right',
	LEFT: 'Left',
} as const;

export const BG_IMAGE_ALIGNMENT_OPTIONS = Object.values(BgImageAlignmentOptions);

export type BgImageAlignmentOptionsName = (typeof BG_IMAGE_ALIGNMENT_OPTIONS)[number];

export const FormSearchParams = [
	'cid',
	'asid',
	'aid',
	'utm_campaign',
	'fb_adset_name',
	'utm_content',
	'utm_medium',
	'utm_source',
	'affid',
	'cr',
	'mediabuy',
	'request_id',
	'pageurl',
	's1',
	's2',
	's3',
	's4',
	's5',
	'lp_test',
	'campaign_id',
	'oid',
];

export const HeaderDefaults = {
	component: {
		options: {
			copy: 'TIME IS LIMITED TO FILE',
			logo: {
				'@type': '@builder.io/core:Reference',
				id: 'a1f2134f8df84c09a576303eae8a5de6',
				model: 'logo',
			},
		},
	},
};

export const FormMessages = {
	SERVER_ERROR: `There is an issue with your form submission.
				Please check your form or try refreshing the page`,
	AD_BLOCK_ERROR: `To authenticate your claim we must verify you are not a robot.
			Please disable your ad-blocker / context blocker and reload the page`,
	REDIRECTING: 'Form submitted successfully! Redirecting',
	CHECKING: 'Submitting your form, this should just take a second',
	FORM_LOAD_ERROR: 'There was an error loading the form. Please try refreshing the page.',
	DEFAULT: '',
};

export const RichTextDefaultArr = [
	'<p><br/></p>',
	'/n',
	'<p><br /></p>',
	'<p></p>',
	'<br/>',
	'<p><br></p>',
];
